"use server";

import { hash } from "bcryptjs";
import { AuthError } from "next-auth";
import { redirect } from "next/navigation";

import { signIn, signOut } from "@/src/auth";
import { prisma } from "@/src/lib/db";

const devUsers = {
  ADMIN: {
    name: "Administrador",
    email: "admin@obanker.local",
  },
  PARCEIRO: {
    name: "Parceiro",
    email: "parceiro@obanker.local",
  },
} as const;

async function redirectForEmail(email: string) {
  const user = await prisma.user.findUnique({ where: { email: email.trim().toLowerCase() } });
  return user?.role === "PARCEIRO" ? "/parceiro" : "/painel";
}

export async function loginAction(
  _prev: string | undefined,
  formData: FormData,
) {
  const email = String(formData.get("email") ?? "");
  try {
    await signIn("credentials", {
      email: formData.get("email"),
      password: formData.get("password"),
      redirectTo: await redirectForEmail(email),
    });
  } catch (error) {
    if (error instanceof AuthError) {
      return "E-mail ou senha inválidos.";
    }

    throw error;
  }
}

export async function logoutAction() {
  await signOut({ redirect: false });
  redirect("/login");
}

export async function devLoginAction(
  _prev: string | undefined,
  formData: FormData,
) {
  if (process.env.NODE_ENV !== "development") {
    return "Acesso rápido disponível só em desenvolvimento.";
  }

  const role = formData.get("role") === "PARCEIRO" ? "PARCEIRO" : "ADMIN";
  const account = devUsers[role];
  const passwordHash = await hash("password", 10);

  await prisma.user.upsert({
    where: { email: account.email },
    update: { role, name: account.name, passwordHash },
    create: {
      name: account.name,
      email: account.email,
      passwordHash,
      role,
    },
  });

  try {
    await signIn("credentials", {
      email: account.email,
      password: "password",
      redirectTo: role === "PARCEIRO" ? "/parceiro" : "/painel",
    });
  } catch (error) {
    if (error instanceof AuthError) {
      return "Não foi possível entrar com o acesso rápido.";
    }

    throw error;
  }
}
